import { Box, Container, Flex, Link, Text } from '@chakra-ui/react';
import { PATENT_NUMBER, PATENT_URL } from '../constants';

export function Footer() {
  return (
    <Box
      as="footer"
      flexShrink={0}
      py={{ base: 4, md: 6 }}
      borderTop="1px solid"
      borderColor="whiteAlpha.100"
    >
      <Container maxW="container.content" px={{ base: 4, md: 6 }}>
        <Flex
          justify="center"
          align="center"
          gap={2}
          flexWrap="wrap"
          textAlign="center"
        >
          <Text color="gray.500" fontSize="xs">
            &copy; {new Date().getFullYear()} Evasive.ai
          </Text>
          <Text color="gray.600" fontSize="xs" aria-hidden="true">
            ·
          </Text>
          <Link
            href={PATENT_URL}
            isExternal
            color="gray.500"
            fontSize="xs"
            _hover={{ color: 'gray.300', textDecoration: 'none' }}
          >
            U.S. Patent {PATENT_NUMBER}
          </Link>
        </Flex>
      </Container>
    </Box>
  );
}
